import { render } from "./NewsCarouselEditor.vue?vue&type=template&id=0d8c98be&scoped=true"
import script from "./NewsCarouselEditor.vue?vue&type=script&lang=js"
export * from "./NewsCarouselEditor.vue?vue&type=script&lang=js"

import "./NewsCarouselEditor.vue?vue&type=style&index=0&id=0d8c98be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8c98be"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QItemLabel,QSlider});
